import Vue from 'vue'
import Router from 'vue-router'
import pageRouters from '@/pages/page-routers'
import routerConfig from './router-config-prod'

Vue.use(Router)

export default new Router({
  routes: [
  ].concat(pageRouters
    .map(router => {
      const config = routerConfig[router.name]
      if (config.enabled) {
        return router
      }
    })
  )
})



// WEBPACK FOOTER //
// ./src/router/index.js